import { render, staticRenderFns } from "./CreateBankAccount.vue?vue&type=template&id=7290ba9d"
import script from "./CreateBankAccount.vue?vue&type=script&lang=js"
export * from "./CreateBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports